module.exports = __webpack_public_path__ + "static/media/store.ea2b0078.svg";